import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const dashboard = () => {
  const auth = useAuth();

  async function summary() {
    let retorno;
    try {
        const {data} = await http.get('/dashboard/summary', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  return {summary}
}
